module.exports = __webpack_public_path__ + "img/0Q3A2198_L_WoodMatted_MockedUp.d11979d3.jpg";